<script lang="ts">
	import { page } from '$app/stores';
</script>

<footer
	class="xl:hidden backdrop-blur-3xl sticky bottom-0 bg-fx-black border-t border-t-fx-grey-600 py-5 px-8"
>
	<div class="flex justify-between">
		<a href="/home">
			<div
				class="transition ease-in cursor-pointer bg-fx-gradient-14 w-9 h-9"
				class:activePage={$page.url.pathname.split('/')[1] === 'home'}
			>
				<div class="bg-fx-black w-full h-full flex items-center justify-center pb-2.5">
					<img
						src={$page.url.pathname.split('/')[1] == 'home'
							? '/footer/Home_active.svg'
							: '/footer/Home.svg'}
						alt="Home"
						loading="lazy"
					/>
				</div>
			</div>
		</a>

		<a href="/">
			<div
				class="transition ease-in cursor-pointer bg-fx-gradient-14 w-9 h-9"
				class:activePage={$page.url.pathname.split('/')[1] == ''}
			>
				<div class="bg-fx-black w-full h-full flex items-center justify-center pb-2.5">
					<img
						src={$page.url.pathname.split('/')[1] == ''
							? '/footer/Swap_active.svg'
							: '/footer/Swap.svg'}
						alt="Markets"
						loading="lazy"
					/>
				</div>
			</div>
		</a>

		<a href="/perps?market=sETHPERP">
			<div
				class="transition ease-in cursor-pointer bg-fx-gradient-14 w-9 h-9"
				class:activePage={$page.url.pathname.split('/')[1] === 'perps'}
			>
				<div class="bg-fx-black w-full h-full flex items-center justify-center pb-2.5">
					<img
						src={$page.url.pathname.split('/')[1] == 'perps'
							? '/footer/Trade_active.png'
							: '/footer/Trade.png'}
						alt="Swap"
						loading="lazy"
					/>
				</div>
			</div>
		</a>

		<a href="/strategies">
			<div
				class="transition ease-in cursor-pointer bg-fx-gradient-14 w-9 h-9"
				class:activePage={$page.url.pathname.split('/')[1] === 'strategies'}
			>
				<div class="bg-fx-black w-full h-full flex items-center justify-center pb-2.5">
					<img
						src={$page.url.pathname.split('/')[1] == 'strategies'
							? '/footer/Gold_active.webp'
							: '/footer/Gold.webp'}
						alt="strategies"
						loading="lazy"
					/>
				</div>
			</div>
		</a>

		<a href="/wallet">
			<div
				class="transition ease-in cursor-pointer bg-fx-gradient-14 w-9 h-9"
				class:activePage={$page.url.pathname.split('/')[1] === 'wallet'}
			>
				<div class="bg-fx-black w-full h-full flex items-center justify-center pb-2.5">
					<img
						src={$page.url.pathname.split('/')[1] == 'wallet'
							? '/footer/Wallet_active.svg'
							: '/footer/Wallet.svg'}
						alt="Profile"
						loading="lazy"
					/>
				</div>
			</div>
		</a>
	</div>
</footer>

<style>
	.activePage {
		@apply pb-0.5;
	}
</style>
